// extracted by mini-css-extract-plugin
export default {"buttons":"GenPrompt_buttons__8PNJc","btn":"GenPrompt_btn__Zaw40","btnalt":"GenPrompt_btnalt__7DCa2","modal":"GenPrompt_modal__I8Bqx","backdrop":"GenPrompt_backdrop__dygL5"};